/*
 * File: Topbar.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:52 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: July 15, 2024 at 9:02 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';

// Colors
import { ColorValues } from '../../../styles/colors';

// Components
import { IconButton } from '../../IconButton';
import { NavigationDropdown as Dropdown } from '../../NavigationDropdown';

// Constants
import { mobileBreakpoint, AppNavTopbarHeight } from '../../../styles/constants';


/**
 * Styles
 */

export const Topbar = styled.div`
	height: ${AppNavTopbarHeight}px;
	min-height: ${AppNavTopbarHeight}px;
	display: flex;
	background-color: ${({ theme }) => theme.primaryBackground};
	z-index: 5;
	box-shadow: ${ColorValues.navigationShadow};
	border-bottom: 1px solid ${({ theme }) => theme.navigationBorder};
	padding: 0.78rem 0;
	pointer-events: all;
	position: sticky !important;
	width: 100%;
	top: 0px !important;

	* :not(svg,path,div) {
		height: 100%;
	}
	button {
		pointer-events: auto;
		align-items: center;
	}
	.searchBar {
		max-width: none;
    	width: 100%;
		height: 100%;

		@media only screen and (min-width: ${mobileBreakpoint}em) {
			max-width: 400px;
		}
	}
	.paddingLeft {
		margin-left: 20px;
	}
`;

export const TopbarWrapper = styled.div`
	display: flex;
	align-items: center;
	position: relative;

	${({ fullWidth }) => fullWidth && css`
		justify-content: center;
		flex: 1;
	`}
`;

export const ActionPadding = styled.div`
	padding: 2px 0;
	height: 100%;
`;

export const ProfileContainer = styled.div`
	position: relative;
`;

export const ProfileImage = styled.img`
	height: 100%;
	position: absolute;
	bottom: 0px;
	left: 50%;
	transform: translateX(-50%);
`;

export const ProfileImageContainer = styled.div`
	background-color: ${({ theme }) => theme.brandTertiaryBase};
	border-radius: 50%;
	margin-left: 16px;
	width: 38px;
	height: 38px;
	//cursor: pointer;
	overflow: hidden;
	text-align: center;
	position: relative;
`;

export const UnreadBadge = styled.div`
	width: 13px;
	height: 13px !important;
	background-color: ${({ theme }) => theme.brandPrimaryBase};
	border: 2px solid ${({ theme }) => theme.primaryBackground};
	border-radius: 50%;
	position: absolute;
	top: 0px;
	right: 0px;
	margin-right: -4px;
	margin-top: -1px;
`;

export const NavigationToggle = styled(IconButton)`
	height: auto;
	margin-right: 18px;
`;

export const AudioToggle = styled(IconButton)`
	height: auto;
	margin-right: 25px;
`;

export const NavigationDropdown = styled(Dropdown)`
	top: ${AppNavTopbarHeight - 20}px;

	&.auth {
		right: -9px;
	}
`;
